import { useMemo } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../lib/utils';
import { useAuth } from '../../context/AuthContext';

export function useAdminApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const url = (path) => `${getApiBaseUrl()}${path}`;
    const config = (extra = {}) => ({ ...extra, headers: { Authorization: `Bearer ${getToken()}`, ...extra.headers } });
    return {
      get: (path, params) => axios.get(url(path), config(params ? { params } : {})),
      download: (path) => axios.get(url(path), config({ responseType: 'blob' })),
      post: (path, body, extra) => axios.post(url(path), body, config(extra)),
      put: (path, body) => axios.put(url(path), body, config()),
      del: (path) => axios.delete(url(path), config())
    };
  }, [getToken]);
}

export const errorMessage = (err, fallback) => err?.response?.data?.error || fallback;
